export default {
  metaNav: {
    dataProtection: { name: 'Protezione dei dati', url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html' },
  },
  legalNote: 'Premio principale: l’utilizzo gratuito di una Mercedes-Benz EQC per un anno inclusi i costi forfettari per la corrente per la ricarica della vettura. EQC, 408 CV (300 kW), 21,4 kWh/100 km (equivalente in benzina: 2,4 l/100 km), 0 g CO2/km, emissioni di CO2 generate dalla produzione di carburante e/o di corrente: 30 g/km, categoria di efficienza energetica: A.',
  navigation: {
    game: 'Gioco',
    ranking: 'Classifica',
    rankingTeam: 'Classifica dei team',
    guide: 'Survival guide',
    rules: 'Regole del gioco',
    faq: 'FAQ',
    eqc: 'L’EQC',
    prizes: 'Premi',
    partners: 'Partner',
  },
  ranking: {
    rank: 'Posto',
    name: 'Nome',
    nick: 'Nome del giocatore',
    team: 'Nome del team',
    time: 'Tempo di gioco',
  },
  titles: {
    default: 'Electric Quest Zurigo | Il mixed reality game | Mercedes-Benz',
    guide: 'Survival guide | Electric Quest Zürich | Mercedes-Benz',
    rules: 'Regole del gioco | Electric Quest Zürich | Mercedes-Benz',
    faq: 'FAQ | Electric Quest Zürich | Mercedes-Benz',
    eqc: 'Mercedes-Benz EQC | Electric Quest Zurigo',
    prizes: 'Premi | Electric Quest Zurigo | Mercedes-Benz',
    partners: 'Partner | Electric Quest Zurigo | Mercedes-Benz',
  },
  appstores: {
    label: 'Scarica ora su:',
    apple: 'itms-apps://apps.apple.com/ch/app/electric-quest/id1434537643?mt=8',
    google: 'https://play.google.com/store/apps/details?id=com.staay.electricquest',
  },
  footer: {
    title: 'Ti invieremo gli aggiornamenti.',
    newsletter: 'Abbonati alla nostra newsletter! Così ti comunicheremo tutto quello che devi sapere su Electric Quest. Se hai già effettuato la registrazione nell’app, sei già iscritto anche a questa newsletter.',
    social: 'Seguici su:',
    toTop: 'In alto',
    meta: [
      {
        name: 'Protezione dei dati Svizzera',
        url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html',
      },
      {
        name: 'Protezione dei dati Lichtenstein',
        url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html',
      },
      {
        name: '© 2019 Mercedes-Benz Svizzera SA',
        url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/copyright.html',
      },
      {
        name: 'Cookie',
        url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/cookies.html',
      },
      { name: 'Note legali',
        url: 'https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/legal-notice.html',
      },
      { name: 'Condizioni di partecipazione',
        route: '/it/terms',
      },
    ],
  },
  banners: {
    cookies: {
      title: 'Utilizzo dei cookie',
      body: '<p>Noi utilizziamo cookie, tecnologie di tracking e (re)targeting.<p><p>In questo modo vogliamo rendere le nostre pagine web più facili da usare, migliorandole costantemente e mostrando le offerte e la pubblicità più adatte agli utenti. Continuando a utilizzare le pagine web, l’utente acconsente all’utilizzo di cookie.</p><p>Per ulteriori informazioni e opzioni si prega di consultare la nostra <a href="https://www.mercedes-benz.ch/it/passengercars/content-pool/tool-pages/legal/cookies.html" target="_blank">informativa sulla protezione dati e le avvertenze sui cookie</a>.</p>',
    },
  },
  labels: {
    confirm: 'OK',
    newsletter: {
      title: [
        { value: 'mr', name: 'Signor' },
        { value: 'mrs', name: 'Signora' },
      ],
      firstname: 'Nome',
      lastname: 'Cognome',
      email: 'Indirizzo e-mail',
      terms: 'Accetto le <a href="#" data-overlay="terms">disposizioni in materia di protezione dei dati</a>.',
      registernow: 'All’iscrizione',
      send: 'Invia il modulo',
      pending: 'Grazie! Ti abbiamo appena inviato un’e-mail di conferma.',
      error: 'Ti preghiamo di riempire tutti i campi, indicando anche un indirizzo e-mail valido.',
    },
  },
};
